import React from 'react'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import DaySelectorItem from './DaySelectorItem'
import LeftArrowIcon from '../../assets/LeftArrowIcon'
import RightArrowIcon from '../../assets/RightArrowIcon'

const DaySelectorBanner = (props) => {
  const {
    dateFormatted,
    dateArr,
    handleDateSelectorClick,
    handleLeftArrowClick,
    handleRightArrowClick,
  } = props

  const rightDisabled = moment(dateArr[3]).isAfter(moment())

  const daySelectorBanner = dateArr.map(dateEl => (
    <DaySelectorItem
      className={dateEl === dateFormatted ? 'selected' : ''}
      key={dateEl}
      data={moment(dateEl)}
      handleClick={handleDateSelectorClick}
    />
    ))

  return (
    <div className={'daySelectorBanner'}>
      <div
        key="leftArrow"
        onClick={handleLeftArrowClick}
        className={'arrowDiv'}
        role="button"
        tabIndex="-1"
      >
        <LeftArrowIcon
          className={'arrowIcon'}
        />
      </div>
      {daySelectorBanner}
      <div
        key="rightArrow"
        onClick={() => handleRightArrowClick(rightDisabled)}
        className={`arrowDiv ${rightDisabled ? 'disabled' : ''}`}
        role="button"
        tabIndex="-1"
      >
        <RightArrowIcon
          className={'arrowIcon'}
          disabled={rightDisabled}
        />
      </div>
    </div>
  )
}

DaySelectorBanner.propTypes = {
  dateFormatted: PropTypes.string.isRequired,
  dateArr: PropTypes.array.isRequired,
  handleDateSelectorClick: PropTypes.func.isRequired,
  handleLeftArrowClick: PropTypes.func.isRequired,
  handleRightArrowClick: PropTypes.func.isRequired,
}

export default DaySelectorBanner



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/DaySelectorBanner.js